import View from "./webhooks.view";
import Presenter from "./webhooks.presenter";
import { ConnectComponent2 } from "util";

export default ConnectComponent2(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/webhooks/index.js